import React from 'react';
const comparisonRows = [{
  without: 'Decisiones improvisadas → ansiedad constante',
  with: 'Claridad en decisiones → tranquilidad'
}, {
  without: 'Conflictos familiares → discusiones repetidas',
  with: 'Comunicación estructurada → acuerdos'
}, {
  without: 'Sobrecarga en una persona → agotamiento',
  with: 'Roles claros → equilibrio familiar'
}, {
  without: 'No saber qué hacer ante cambios → bloqueo',
  with: 'Sistema claro → acción segura'
}, {
  without: 'Reaccionar ante crisis → estrés extremo',
  with: 'Anticiparte a las crisis → control'
}, {
  without: 'Sentimiento de culpa constante → desgaste',
  with: 'Acompañamiento consciente → paz mental'
}, {
  without: 'Falta de orden en documentos y salud → caos',
  with: 'Todo organizado → eficiencia y rapidez'
}, {
  without: 'Perder tu propia vida en el proceso → vacío',
  with: 'Cuidado sostenible → mantienes tu bienestar'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-76">
      <div className="max-w-xl mx-auto" data-id="element-77">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-78">
          📚 TABLA COMPARATIVA — SISTEMA FAMILIA ORGANIZADA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-79">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-80">
            ❌ Sin el sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-81">
            ✅ Con MEGAPACK + Sistema
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-82">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-gray-800/60 pt-3" data-id="element-83">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-84">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-85">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}